module.exports = __webpack_public_path__ + "img/freespin1_multiplier3.61d6a7f0.png";